import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=50133804&scoped=true&"
import script from "./ArticleForm.vue?vue&type=script&lang=js&"
export * from "./ArticleForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=50133804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50133804",
  null
  
)

export default component.exports